module.exports = __webpack_public_path__ + "static/img/6101_phase_function_Paper_PointsHejduk_Prediction.dd7d049.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6101_phase_function_Paper_PointsHejduk_Prediction.png
// module id = J5id
// module chunks = 0